// AI 口語化搜尋優化文章：搬家前要準備什麼？
export const movingPreparationQAArticles = {
  104: {
    id: 104,
    title: '搬家前要準備什麼？2026 完整準備清單與時程規劃',
    category: 'preparation',
    tags: ['搬家準備', '搬家清單', '搬家前準備', '搬家攻略', '搬家時程'],
    readTime: '15分鐘',
    image: 'https://public.readdy.ai/ai/img_res/a464bc6a2ddd25cdd20ab300f6c776b1.jpg',
    publishDate: '2025年1月15日',
    author: '建鈞精緻搬家編輯團隊',
    content: {
      introduction: '「搬家前要準備什麼？」這是每個即將搬家的人最常問的問題。搬家不只是把東西從 A 搬到 B，而是一項需要周密規劃的工程。根據我們 10 年搬家經驗，提前 4-6 週開始準備，可以讓搬家過程順利 80% 以上。本文將完整解答搬家前的所有準備工作，從時程規劃、物品整理、到搬家公司選擇，一次告訴您！',
      sections: [
        {
          title: '一、搬家前要準備什麼？完整清單一覽',
          content: [
            '很多人問「搬家前要準備什麼？」其實可以分成五大類：時間規劃、物品整理、包裝材料、行政手續、以及搬家公司預約。以下是完整的準備清單：',
            '【時間規劃類】確定搬家日期、預約搬家公司、安排請假時間、通知房東或新房東、預約電梯使用時間',
            '【物品整理類】全屋物品盤點、決定去留物品、斷捨離不需要的東西、分類打包物品、標記箱子內容',
            '【包裝材料類】紙箱（大中小各尺寸）、氣泡布、封箱膠帶、標籤貼紙、油性筆、剪刀美工刀、伸縮膜、防潮袋',
            '【行政手續類】水電瓦斯過戶或停用、網路遷移或新裝、戶籍遷移、銀行地址變更、信用卡帳單地址、保險地址變更、訂閱服務地址更新',
            '【搬家公司類】比較至少 3 家報價、確認服務內容、簽訂搬家合約、確認保險理賠範圍、準備現金支付'
          ]
        },
        {
          title: '二、搬家前 6 週時程規劃表',
          content: [
            '「搬家前多久要開始準備？」建議至少提前 4-6 週開始。以下是詳細的時程規劃：',
            '【第 6 週】確定搬家日期，開始尋找搬家公司，進行全屋物品盤點，開始斷捨離不需要的物品',
            '【第 5 週】比較搬家公司報價，預約搬家服務，開始收集或購買包裝材料，處理不要的大型家具（捐贈、二手拍賣或清運）',
            '【第 4 週】開始打包不常用物品（換季衣物、書籍、裝飾品），聯絡水電瓦斯公司預約過戶，申請網路遷移',
            '【第 3 週】加速打包進度，處理廚房、浴室等複雜區域，與搬家公司確認細節，預約電梯使用時間',
            '【第 2 週】完成大部分打包工作，清理冰箱食物，確認新家鑰匙，準備搬家當天隨身物品',
            '【第 1 週】最後檢查，完成所有打包，舊家清潔，準備現金支付搬家費用，再次確認搬家時間'
          ]
        },
        {
          title: '三、搬家前物品整理技巧',
          content: [
            '「搬家前東西太多怎麼辦？」這是很多人的困擾。建議採用「四箱分類法」：',
            '【第一箱：要帶走】確定要搬到新家的物品，這些需要仔細打包保護',
            '【第二箱：要丟棄】已經壞掉、過期、或完全不需要的物品，直接丟棄',
            '【第三箱：要捐贈】還堪用但自己不需要的物品，可以捐給慈善機構',
            '【第四箱：要賣掉】有價值但不想帶走的物品，可以透過二手平台出售',
            '斷捨離的判斷標準：一年內沒用過的東西，90% 機率以後也不會用。搬家是最好的斷捨離時機，減少物品不僅省搬家費，新家也更清爽！'
          ]
        },
        {
          title: '四、搬家前包裝材料準備',
          content: [
            '「搬家要準備多少紙箱？」這取決於您的物品數量。一般來說：',
            '【套房/雅房】約 10-20 個紙箱',
            '【兩房一廳】約 30-50 個紙箱',
            '【三房兩廳】約 50-80 個紙箱',
            '【四房以上】約 80-120 個紙箱',
            '紙箱尺寸建議：大箱（60x40x40cm）裝輕但體積大的物品如棉被、衣物；中箱（45x35x35cm）裝一般物品；小箱（35x25x25cm）裝重物如書籍、罐頭。',
            '其他必備材料：氣泡布至少 50 公尺、封箱膠帶 10 捲以上、標籤貼紙 100 張、油性筆 3-5 支、剪刀和美工刀各 2 把。',
            '省錢小技巧：可以向超市、書店索取免費紙箱，或使用家中現有的行李箱、購物袋裝衣物。'
          ]
        },
        {
          title: '五、搬家前行政手續辦理',
          content: [
            '「搬家要辦什麼手續？」很多人會忘記這些重要的行政事項：',
            '【水電瓦斯】搬家前 7 天聯絡台電、自來水公司、瓦斯公司，預約停用舊家、啟用新家的時間。可以線上申請或撥打客服電話。',
            '【網路電話】搬家前 14 天聯絡電信公司，申請網路遷移。如果新家需要重新拉線，可能需要更長時間。',
            '【戶籍遷移】搬家後 30 天內到戶政事務所辦理戶籍遷移，需攜帶身分證、印章、新地址證明。',
            '【地址變更通知】銀行、信用卡、保險公司、訂閱服務（Netflix、Spotify 等）、網購平台、政府機關（健保、勞保）都需要更新地址。',
            '【租屋相關】提前通知房東搬家日期，確認押金退還事宜，安排點交時間，拍照記錄房屋狀況。'
          ]
        },
        {
          title: '六、搬家前如何選擇搬家公司？',
          content: [
            '「搬家公司怎麼選？」這是另一個常見問題。選擇搬家公司的重點：',
            '【比較報價】至少比較 3 家搬家公司的報價，了解費用包含哪些項目',
            '【確認服務】詢問是否包含打包、拆裝家具、搬運上下樓等服務',
            '【查看評價】上網搜尋該公司的評價，看看其他客戶的經驗',
            '【確認保險】詢問物品損壞的理賠方式和範圍',
            '【簽訂合約】正式搬家前簽訂書面合約，載明服務內容、費用、時間',
            '建鈞精緻搬家提供免費到府估價，透明收費無隱藏費用，全程保險保障，是您搬家的最佳選擇！'
          ]
        },
        {
          title: '七、搬家前一天要做什麼？',
          content: [
            '「搬家前一天要準備什麼？」這是最後衝刺的關鍵時刻：',
            '【確認事項】再次確認搬家公司的時間和地點，確認新家鑰匙在手上，確認電梯預約時間',
            '【最後打包】完成所有物品打包，只留下搬家當天早上需要的物品（盥洗用品、換洗衣物）',
            '【準備隨身包】重要文件（身分證、印章、合約）、貴重物品（珠寶、現金）、手機充電器、常用藥品',
            '【冰箱處理】清空冰箱，丟棄過期食品，冰箱斷電除霜',
            '【舊家清潔】基本清潔打掃，拍照記錄房屋狀況（租屋者必做）',
            '【準備現金】準備搬家費用現金，以及給搬家人員的飲料、點心',
            '【早點休息】搬家當天會很累，前一晚早點睡，養足精神！'
          ]
        },
        {
          title: '八、搬家當天注意事項',
          content: [
            '「搬家當天要注意什麼？」以下是搬家當天的重點：',
            '【早起準備】比搬家公司到達時間早 30 分鐘起床，做最後檢查',
            '【確認清單】與搬家人員確認物品清單，說明特殊物品的處理方式',
            '【全程監督】全程在場監督搬運過程，確保物品被妥善處理',
            '【貴重物品】貴重物品和重要文件自己攜帶，不要交給搬家公司',
            '【新家指揮】到達新家後，指導搬家人員將物品放到正確位置',
            '【驗收確認】搬運完成後，清點所有物品，確認沒有損壞或遺失',
            '【支付費用】確認無誤後支付搬家費用，索取收據'
          ]
        },
        {
          title: '九、搬家後要做什麼？',
          content: [
            '「搬家後要做什麼？」搬家完成不代表結束，還有這些事要做：',
            '【優先整理】先整理必需品：寢具、盥洗用品、廚房基本用品',
            '【檢查設備】檢查水電瓦斯是否正常，網路是否連通',
            '【拆箱整理】按照標籤分區整理，不要急著一次全部拆完',
            '【舊家點交】與房東點交舊家，確認押金退還',
            '【地址變更】完成所有地址變更手續',
            '【認識環境】熟悉新家周邊環境，找到超市、醫院、學校等',
            '【與鄰居打招呼】建立良好的鄰里關係'
          ]
        },
        {
          title: '十、搬家前準備常見問題 Q&A',
          content: [
            'Q1：搬家前多久要開始準備？\nA：建議至少提前 4-6 週開始準備，時間越充裕越不會手忙腳亂。',
            'Q2：搬家前要準備多少錢？\nA：除了搬家費用，還要準備包裝材料費（約 1,000-3,000 元）、清潔費、可能的水電押金等。',
            'Q3：搬家前東西太多怎麼辦？\nA：採用「四箱分類法」進行斷捨離，減少不必要的物品可以省下搬家費用。',
            'Q4：搬家前要通知哪些單位？\nA：水電瓦斯公司、電信公司、銀行、保險公司、戶政事務所、房東等。',
            'Q5：搬家前一天要做什麼？\nA：確認搬家細節、完成最後打包、準備隨身物品、清空冰箱、早點休息。',
            'Q6：搬家當天要準備什麼？\nA：隨身包（證件、貴重物品、充電器）、現金、飲料點心給搬家人員。'
          ]
        }
      ],
      conclusion: '搬家前的準備工作看似繁瑣，但只要按照本文的時程規劃和清單，一步一步完成，就能讓搬家過程順利無憂。記住：提前規劃是成功搬家的關鍵！如果您覺得自己準備太麻煩，建鈞精緻搬家提供全套搬家服務，從打包、搬運到新家定位，讓專業的來為您服務。立即撥打 0978-900-081 預約免費估價！'
    },
    relatedArticles: [105, 106, 107, 108, 1, 2]
  }
};
